import { render, staticRenderFns } from "./userHelp.vue?vue&type=template&id=3913a37a&scoped=true&"
import script from "./userHelp.vue?vue&type=script&lang=js&"
export * from "./userHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3913a37a",
  null
  
)

export default component.exports